(function () {
  'use strict';

  function initDeliverySection(root) {
    var cards = root.querySelectorAll('[data-ix-card]');

    /* ---------- Accordion toggle ---------- */
    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-ix-toggle]');
      var panel = card.querySelector('[data-ix-panel]');
      if (!trigger || !panel) return;

      function recalcHeight() {
        if (card.hasAttribute('data-open')) {
          // 'none' lets the browser report the panel's true natural height,
          // including any content that changed size since the panel opened.
          panel.style.maxHeight = 'none';
          var naturalHeight = panel.scrollHeight;
          panel.style.maxHeight = naturalHeight + 'px';
        }
      }

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(function () {
          recalcHeight();
        });
        resizeObserver.observe(panel);
      } else {
        window.addEventListener('resize', recalcHeight);
      }

      trigger.addEventListener('click', function () {
        var isOpen = card.hasAttribute('data-open');

        // Close all other cards in this section (one open at a time)
        cards.forEach(function (other) {
          if (other === card) return;
          var otherPanel = other.querySelector('[data-ix-panel]');
          var otherTrigger = other.querySelector('[data-ix-toggle]');
          other.removeAttribute('data-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) {
            otherPanel.style.maxHeight = '0px';
            otherPanel.setAttribute('hidden', '');
          }
        });

        if (isOpen) {
          card.removeAttribute('data-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '0px';
          window.setTimeout(function () {
            panel.setAttribute('hidden', '');
          }, 550);
        } else {
          card.setAttribute('data-open', '');
          trigger.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
          // force reflow then measure
          panel.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
        }
      });
    });

    /* ---------- Scroll reveal ---------- */
    if ('IntersectionObserver' in window) {
      cards.forEach(function (card) {
        card.classList.add('ix-will-animate');
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }
    /* If IntersectionObserver is unavailable, cards simply stay visible (no .ix-will-animate added) */
  }

  function boot() {
    document.querySelectorAll('.ix-delivery').forEach(initDeliverySection);
  }

  /* ---------- Fix: mobile menu drawer can leave the page scroll-locked
     when navigating via a hash link (e.g. tapping "Lieferung & Abholung"
     in the mobile menu). Shopify's header-drawer component only clears
     its open state and scroll-lock once a CSS transition's
     "animationend"/"transitionend" event fires (see header-drawer.js
     #close()). If the hash-jump interrupts that transition before it
     completes, the event never fires, the drawer's <details open>
     attribute and scroll-lock attribute are never cleared, and the
     page stays unscrollable. This replicates that cleanup directly. */
  function releaseMenuScrollLockIfStuck() {
    function unlock() {
      var openDrawers = document.querySelectorAll(
        'header-drawer details[open], details.menu-drawer-container[open], details[scroll-lock][open]'
      );
      openDrawers.forEach(function (details) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });

      // Belt-and-suspenders: if some other mechanism still left html/body
      // locked, clear common scroll-lock styles/classes too.
      [document.documentElement, document.body].forEach(function (el) {
        if (!el) return;
        if (el.style.overflow === 'hidden') el.style.overflow = '';
        if (el.style.position === 'fixed') el.style.position = '';
      });
    }

    // Run once shortly after load, and again after the browser's own
    // hash-jump settles, since the lock can still be mid-transition then.
    window.setTimeout(unlock, 50);
    window.setTimeout(unlock, 400);
    window.setTimeout(unlock, 1000);
  }

  releaseMenuScrollLockIfStuck();

  // Also catch the case where the page was already loaded and the person
  // taps a hash link inside the (open) mobile menu — listen for the click
  // itself so cleanup runs immediately rather than waiting on a timer.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('#') === -1) return;

      window.setTimeout(releaseMenuScrollLockIfStuck, 50);
      window.setTimeout(releaseMenuScrollLockIfStuck, 400);
      window.setTimeout(releaseMenuScrollLockIfStuck, 1000);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor support (re-init on section reload)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ix-delivery');
    if (section) initDeliverySection(section);
  });
})();